import { SecretModel } from '@/adapters/apiv1.g';
import type { Secret } from '@/types/core/secret';
import type { UUID } from '@/utils/uuid';

/**
 * Transform a backend secret response to a frontend Secret type.
 * Note: The API returns 'any' type for secrets, so we handle it carefully.
 * @param data - API secret response
 * @returns Secret - UI-friendly Secret object
 */

export function extractSecret(data: SecretModel): Secret {
  const withRev = data as SecretModel & { _rev?: number };
  return {
    _rev: withRev._rev,
    secretId: (data?.secret_id ?? '') as UUID,
    templateId: data?.template_id as UUID | undefined,
    name: data?.name ?? '',
    status: data?.status ?? '',
    createdAt: data?.created_at,
    rotatedAt: data.rotated_at,
    tmkVersion: data?.tmk_version ?? 0,
    algVersion: data?.alg_version ?? 0,
    isOutdated: data?.is_outdated ?? false,
    activeTmkVersion: data?.active_tmk_version ?? 0,
    activeAlgVersion: data?.active_alg_version ?? 0,
  };
}
